import React from "react";
import WebAppContainer from "@/components/WebAppContainer/WebAppContainer";
import { useCurrentPriceRange } from "@/utils/hooks/useCurrentPriceRange";
import PaymentsModal from "@/features/PaymentsModal/PaymentsModal";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import { useSelectedHexGroupStore } from "@/store/selectedHexGroup";
import { useChooseRegionStore } from "@/store/chooseRegion";
import { useTariffLayer } from "@/store/mode";
import { useTranslation } from "react-i18next";
import { getTariffModeConfig } from "@/utils/tariffModeConfig";
import cls from "./styles.module.scss";

export const PriceScale = ({
  min,
  max,
  id,
}: {
  min: number;
  max: number;
  id?: string;
}) => {
  const { t } = useTranslation();
  const selectedHexGroup = useSelectedHexGroupStore((s) => s.selectedHexGroup);
  const { setChooseRegion } = useChooseRegionStore();
  const tariffLayer = useTariffLayer((s) => s.tariffLayer);
  const gradientColors = getTariffModeConfig(tariffLayer).colorScale;
  const gradient = `linear-gradient(90deg, ${gradientColors.join(", ")})`;

  return (
    <button
      type="button"
      id={id}
      className={cls.scale}
      onClick={() => setChooseRegion(true)}
    >
      <div className={cls.scalePrice}>
        {selectedHexGroup ? selectedHexGroup?.name : t("common.russia")}
      </div>
      <div className={cls.scaleValues}>
        {selectedHexGroup && <p className={cls.scalePrice}>{min}₽</p>}
        <div className={cls.scaleGradient} style={{ background: gradient }} />
        {selectedHexGroup && <p className={cls.scalePrice}>{max}₽</p>}
      </div>
    </button>
  );
};

export default function MapHeader() {
  const selectedHexGroup = useSelectedHexGroupStore((s) => s.selectedHexGroup);
  const { min: currentMin, max: currentMax } = useCurrentPriceRange() ?? {
    min: 0,
    max: 0,
  };
  const { min, max } = selectedHexGroup
    ? { min: currentMin, max: currentMax }
    : { min: 0, max: 0 };

  return (
    <WebAppContainer>
      <FlexRow
        className={cls.header}
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <FlexColumn gap={16}>
          <PaymentsModal />
        </FlexColumn>

        <PriceScale min={min} max={max} id="scaleStep" />
      </FlexRow>
    </WebAppContainer>
  );
}
